import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiDashboardChoiceWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { DashboardChoiceCard } from './DashboardChoiceCard';

/**
 * The `bi_dashboard_choice` fence: which dashboard the drafts go on. The
 * server writes it in reply to an add tap; each choice is a tap again.
 */
export const BiDashboardChoiceWidget = memo(({ data }: { data: unknown }) => {
  const payload = parseBiDashboardChoiceWidgetPayload(data);
  if (!payload) return <CardNotice text="这个看板选择无效，请重新添加图表。" />;
  return <DashboardChoiceCard payload={payload} />;
});
